import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IOpenUserManagementService } from '@app/shared/auth/user-management/open-user-management-service';
import { OPEN_USER_MANAGEMENT } from '@app/shared/auth/user-management/open-user-management.token';
import { MenuUserButtonItem } from '../menu-user-button-item';

@Component({
  selector: 'app-user-management-menu-item',
  imports: [MenuUserButtonItem, MatIcon],
  templateUrl: './user-management-menu-item.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-management-menu-item.scss',
})
export class UserManagementMenuItem {
  openUserManagementService = inject<IOpenUserManagementService>(OPEN_USER_MANAGEMENT);
}
